export default __webpack_public_path__ + "static/media/Bankscreen-Cards.b1492fea.png";